<wm-data-entity-input
  *ngIf="dataEntity"
  [entity]="dataEntity"
  [form]="form"
  [applicationId]="applicationId"
  [activity]="activity"
  #selectContractor
></wm-data-entity-input>

